import { History as HistoryIcon, Link } from '@amzn/ring-ui-react-components';
import { useIsDesktop } from '../../hooks';
import { Box } from '../Box';
import { Button } from '../Button';
import { Flex } from '../Flex';
import { CenteredLoading } from '../Loading';

export const RingHistoryUploader = ({
  hasFiles = false,
  handleRingHistoryUploaderClick = (): void => {},
  devices = { loading: true },
  ...props
}) => {
  const isDesktop = useIsDesktop();

  const title = isDesktop
    ? 'Upload from your Ring History'
    : 'Upload from Ring History';

  if (isDesktop) {
    return (
      <>
        <Flex
          {...props}
          py={hasFiles ? 4 : 6}
          flex={1}
          bg="neutral.50"
          borderColor="tertiary.500"
          alignItems="center"
          borderRadius="round"
          borderStyle="solid"
          borderWidth="2px"
          cursor="pointer"
          flexDirection="column"
          overflow="hidden"
          textAlign="center"
          onClick={handleRingHistoryUploaderClick}
          transition="all 250ms ease"
          _focus={{
            outline: 'none',
          }}
          _hover={{
            borderColor: 'primary.500',
          }}
        >
          <Flex
            alignItems="center"
            flexDirection={hasFiles ? 'row' : 'column'}
            justifyContent="center"
            px={5}
            py={hasFiles ? 4 : 6}
            width={1}
          >
            <Flex
              alignItems="center"
              flexDirection={hasFiles ? 'row' : 'column'}
              mb={hasFiles ? 0 : 2}
            >
              {hasFiles ? (
                <HistoryIcon color="primary.400" boxSize="24px" />
              ) : (
                <HistoryIcon color="primary.500" boxSize="48px" />
              )}
              <Box
                ml={hasFiles ? 2 : 0}
                mt={hasFiles ? 0 : 1}
                textAlign={hasFiles ? 'left' : 'center'}
              >
                <Box textStyle="body-normal-medium">
                  {hasFiles ? (
                    <Link textDecoration="underline">{title}</Link>
                  ) : (
                    title
                  )}
                </Box>
              </Box>
            </Flex>
            {!hasFiles && !devices.loading && (
              <Button
                px={7}
                py={2}
                size="lg"
                variant={hasFiles ? 'empty' : 'primary'}
                borderRadius="8px"
                mt={6}
              >
                Event History
              </Button>
            )}
            {devices.loading && (
              <Flex style={{ marginTop: 34 }}>
                <CenteredLoading />
              </Flex>
            )}
          </Flex>
        </Flex>
      </>
    );
  }

  return (
    <>
      <Flex
        {...props}
        py={6}
        flex={1}
        width="100%"
        bg="neutral.50"
        borderColor="tertiary.500"
        alignItems="center"
        justifyContent="center"
        borderRadius="round"
        borderStyle="solid"
        borderWidth="2px"
        cursor="pointer"
        flexDirection="row"
        overflow="hidden"
        textAlign="center"
        onClick={handleRingHistoryUploaderClick}
        transition="all 250ms ease"
        _focus={{
          outline: 'none',
        }}
        _hover={{
          borderColor: 'primary.500',
        }}
      >
        {!devices.loading && (
          <Flex>
            <HistoryIcon color="primary.400" boxSize="24px" />
            <Link ml={2} textDecoration="underline">
              Upload from Ring History
            </Link>
          </Flex>
        )}
        {devices.loading && <CenteredLoading />}
      </Flex>
    </>
  );
};
